import { render, staticRenderFns } from "./OrganisationDashboardSubscriptions.vue?vue&type=template&id=3520c341&"
import script from "./OrganisationDashboardSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./OrganisationDashboardSubscriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3520c341')) {
      api.createRecord('3520c341', component.options)
    } else {
      api.reload('3520c341', component.options)
    }
    module.hot.accept("./OrganisationDashboardSubscriptions.vue?vue&type=template&id=3520c341&", function () {
      api.rerender('3520c341', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organisations/organisationDashboard/OrganisationDashboardSubscriptions.vue"
export default component.exports